import type {ReactNode} from 'react';

import {InlineNotification} from '@/components/ui/InlineNotification';
import type {InlineNotificationProps} from '@/components/ui/InlineNotification/InlineNotification';
import {INLINE_NOTIFICATION_VARIANTS, type InlineNotificationVariant} from '@/consts/inlineNotification';
import type {InlineNotificationModel} from '@/types/aem';
import {twx} from '@/utils/tailwindUtils';

import styles from './AemInlineNotification.module.css';

type AemInlineNotificationProps = InlineNotificationProps & {
    model?: InlineNotificationModel | null;
    variant?: InlineNotificationVariant;
    trailingNode?: ReactNode;
    gradientWrapperClassName?: string;
};

const AemInlineNotification = ({
    model,
    variant = INLINE_NOTIFICATION_VARIANTS.DEFAULT,
    trailingNode,
    className,
    gradientWrapperClassName,
    ...rest
}: AemInlineNotificationProps) => {
    if (!model) {
        return null;
    }

    const {title, description} = model;

    if (!title && !description) {
        return null;
    }

    const isGradientVariant = variant === INLINE_NOTIFICATION_VARIANTS.GRADIENT;

    const mergedProps: InlineNotificationProps = {
        title,
        body: description,
        className: twx(isGradientVariant && 'rounded-2xl bg-secondary', className),
        contentClassName: isGradientVariant ? 'text-romance' : undefined,
        trailingNode,
        ...rest,
    };

    if (isGradientVariant) {
        return (
            <div className={twx('rounded-2xl p-0.5', styles.GradientBorderAnimated, gradientWrapperClassName)}>
                <InlineNotification {...mergedProps} />
            </div>
        );
    }

    return <InlineNotification {...mergedProps} />;
};

export default AemInlineNotification;
